import { render, staticRenderFns } from "./ImageDeleteDialog.vue?vue&type=template&id=0ab80000&"
import script from "./ImageDeleteDialog.vue?vue&type=script&lang=js&"
export * from "./ImageDeleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./ImageDeleteDialog.vue?vue&type=style&index=0&id=0ab80000&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports